/* eslint-disable array-callback-return */
import React, { useState, useEffect } from 'react';
import styled, { css } from 'styled-components';
import { Button, Space, Switch, Modal } from 'antd';
import { theme, Text, TableComponent } from '@pfmam/pfmam';
import { Box, Container } from '../../styles/globalStyle';
import NoDataFound from '../../common/components/noDataFound';
import { DownloadOutlined, EyeOutlined, FileOutlined } from '@ant-design/icons';
import moment from 'moment';
import ExpandInputComponent from '../../common/components/expandInput';
import MultiSelect from '../../common/components/multiSelect';
import RenderDatePicker from '../../common/components/datePicker';
import CheckboxImg from '../../assets/images/checkbox-blue.svg';
import CheckboxCheckedImg from '../../assets/images/checkbox-blue-checked.svg';
import { useSelector } from 'react-redux';
import { DownloadFundDocument, GetFundDocumentsInfo, UpdateFundDocumentStatus } from '../../actions/actions';
import {
  base64ToArrayBuffer,
  createAndDownloadBlobFile,
} from '../../utils/download';
const Wrapper = styled.div`
  padding-top: 22px;
`;
const LinkButton = styled(Button)`
  padding: 0;
  display: inline-block;
  font-size: ${theme.font_size.size_lg};
  line-height: 20px;
  color: ${theme.colors.blue_primay};
  height: 20px;
  border: 0;
  background: none;
  box-shadow: none;
  :hover {
    opacity: 0.6;
    color: ${theme.colors.blue_primay};
  }
  :focus,
  :active {
    opacity: 1;
    color: ${theme.colors.blue_primay};
    background: none;
  }
  .anticon + span {
    margin-left: 8px;
  }
  ${(props) =>
    props.cancel &&
    css`
      color: ${theme.colors.danger_red};
      :hover {
        opacity: 0.6;
        color: ${theme.colors.danger_red};
      }
      :focus,
      :active {
        opacity: 1;
        color: ${theme.colors.danger_red};
        background: none;
      }
    `}
`;
const CustomSwitch = styled(Switch)`
  background-color: ${(props) => props.checked ? props.linkTextColor : 'lightgray'}
`;
const FundDocumentsComponent = ({refreshFundDocuments, showUploadedBy,showStatus}) => {
  const [searchData, setSearchData] = useState(null);
  const [inputClassName, setInputClassName] = useState('hide');
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewUrl, setPreviewUrl] = useState('');
  const [previewTitle, setPreviewTitle] = useState('');
  const [previewMimeType, setPreviewMimeType] = useState('');

  const [documentTypeSelectedValues, setDocumentTypeSelectedValues] = useState(
    []
  );
  const [documentTypeFilterClass, setDocumentTypeFilterClass] =
    useState('hide');

  const [fundDocumentData, setFundDocumentData] = useState([]);
  const [filteredDocumentData, setFilteredDocumentData] = useState([]);
  const clientDetails = useSelector(
    (state) => state.programsClientsSlice.selectedClient
  );
  const programId = clientDetails.payload[0].programid;
  const ssnorTIN = clientDetails.payload[0].ssnortin;

  const columns = [
    {
      title: 'Uploaded Date',
      dataIndex: 'UploadedDate',
      key: 'UploadedDate',
      align: 'left',
      sorter: (a, b) =>
        moment(a.UploadedDate).unix() - moment(b.UploadedDate).unix(),
      className: 'sort-space-none',
      render: (text) => (
        <Text label={moment(text).format('MMM DD, YYYY')} lineheight="20px" />
      ),
    },
    ...(showUploadedBy ? [
      {
        title: 'Uploaded By',
        dataIndex: 'UploadedBy',
        key: 'UploadedBy',
        align: 'left',
        sorter: (a, b) =>
          a.UploadedBy.localeCompare(b.UploadedBy),
        className: 'sort-space-none',
        width: '300px',
        render: (text) => (
          <Text label={text} lineheight="20px" />
        ),
      },
    ] : []),
    {
      title: 'Document',
      dataIndex: 'FileName',
      key: 'FileName',
      align: 'left',
      sorter: (a, b) => a.FileName.localeCompare(b.FileName ),
      className: 'sort-space-none',
      width: 500,
    },
    ...(
      showStatus
        ? [{
            title: 'Status',
            dataIndex: 'StatusId',
            key: 'StatusId',
            align: 'center',
            render: (statusId, record) => (
              <CustomSwitch
               linkTextColor={primary_color}
                checked={statusId === 2}
                checkedChildren="Active"
                unCheckedChildren="Inactive"
                onChange={() => handleToggleStatus(record)}
              />
            )
          }]
        : []
    ),
    {
      title: '',
      dataIndex: 'preview',
      key: 'preview',
      align: 'right',
      render: (_, record) => (
        <LinkButton
          type="link"
          onClick={(e) => {
            e.stopPropagation();
            handlePreview(record);
          }}
        >
          <EyeOutlined />
          Preview
        </LinkButton>
      ),
    },
    {
      title: '',
      dataIndex: 'action',
      key: 'action',
      align: 'right',
      render: (_, record) => (
        <LinkButton
          type="link"
          onClick={(e) => {
            e.stopPropagation();
            handleAction(record);
          }}
        >
          <DownloadOutlined />
          Download
        </LinkButton>
      ),
    },
  ];

     // Toggle document status (active/inactive)
    const handleToggleStatus = (record) => {
      const newStatusId = record.StatusId==2 ? 1 : 2; // Assuming 1 = Inactive, 2 = Active
      UpdateFundDocumentStatus(record.DocumentId, newStatusId)
        .then((response) => {
          // Optionally show a success message
          // Refresh the document list
          GetFundDocumentsInfo(programId)
            .then((response) => {
              if (response.data != null) {
                setFundDocumentData(response.data);
                setFilteredDocumentData(response.data);
              }
            });
        })
        .catch((error) => {
          console.log(error);
          alert('Failed to update document status.');
        });
    };

  const onInputSubmit = (searchstring) => {
    setSearchData(searchstring);
  };

  useEffect(() => {
    GetFundDocumentsInfo(programId)
      .then((response) => {
        if (response.data != null) {
          setFundDocumentData(response.data);
          setFilteredDocumentData(response.data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [programId, refreshFundDocuments]);

  useEffect(() => {
    if (!searchData || searchData.trim() === "") {
      setFilteredDocumentData(fundDocumentData);
    } else {
      setFilteredDocumentData(
        fundDocumentData.filter((doc) =>
          doc.FileName && doc.FileName.toLowerCase().includes(searchData.toLowerCase())
        )
      );
    }
  }, [searchData, fundDocumentData]);

  const detectMimeType = (fileName, bytes) => {
    // Check magic bytes first
    if (bytes && bytes.length >= 4) {
      const header = bytes.slice(0, 4);
      // PDF: %PDF
      if (header[0] === 0x25 && header[1] === 0x50 && header[2] === 0x44 && header[3] === 0x46) {
        return 'application/pdf';
      }
      // PNG: 89 50 4E 47
      if (header[0] === 0x89 && header[1] === 0x50 && header[2] === 0x4E && header[3] === 0x47) {
        return 'image/png';
      }
      // JPEG: FF D8 FF
      if (header[0] === 0xFF && header[1] === 0xD8 && header[2] === 0xFF) {
        return 'image/jpeg';
      }
      // GIF: GIF8
      if (header[0] === 0x47 && header[1] === 0x49 && header[2] === 0x46 && header[3] === 0x38) {
        return 'image/gif';
      }
    }
    // Fallback to file extension
    if (fileName) {
      if (fileName.match(/\.(pdf)$/i)) return 'application/pdf';
      if (fileName.match(/\.(jpg|jpeg)$/i)) return 'image/jpeg';
      if (fileName.match(/\.(png)$/i)) return 'image/png';
      if (fileName.match(/\.(gif)$/i)) return 'image/gif';
      if (fileName.match(/\.(bmp)$/i)) return 'image/bmp';
      if (fileName.match(/\.(webp)$/i)) return 'image/webp';
      if (fileName.match(/\.(svg)$/i)) return 'image/svg+xml';
    }
    return 'application/octet-stream';
  };

  const handlePreview = (data) => {
    DownloadFundDocument(data.DocumentId)
      .then((response) => {
        if (response.data != null && response.data.length > 0) {
          const arrayBuffer = base64ToArrayBuffer(response.data);
          const uint8 = new Uint8Array(arrayBuffer);
          const mimeType = detectMimeType(data.FileName, uint8);
          const blob = new Blob([arrayBuffer], { type: mimeType });
          const url = URL.createObjectURL(blob);
          setPreviewUrl(url);
          setPreviewTitle(data.FileName);
          setPreviewMimeType(mimeType);
          setPreviewVisible(true);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handlePreviewClose = () => {
    setPreviewVisible(false);
    URL.revokeObjectURL(previewUrl);
    setPreviewUrl('');
    setPreviewMimeType('');
  };

  const handleAction = (data) => {
    DownloadFundDocument(data.DocumentId)
      .then((response) => {
        if (response.data != null && response.data.length > 0) {
          const arrayBuffer = base64ToArrayBuffer(response.data);
          // Remove .pdf extension from filename if present
          let fileName = data.FileName.replace(/\.pdf$/i, "");
          createAndDownloadBlobFile(arrayBuffer, fileName);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const primary_color = useSelector((state) => state.siteInfo.primaryColor);
  return (
    <>
      <Container>
        <Wrapper>
          <Box margin="0 0 24px">
            <Space size={8}>
              <ExpandInputComponent
                onInputSubmit={onInputSubmit}
                inputClassName={inputClassName}
                setInputClassName={setInputClassName}
              />
            </Space>
          </Box>
          <TableComponent
            rowKey="DocumentId"
            className="table-primary"
            title={
              <Box
                display="flex"
                justifycontent="space-between"
                alignitems="center"
                padding="24px 48px 24px 32px"
                border={`1px solid ${theme.colors.grey_fossil}`}
                borderwidth="0 0 1px 0"
              >
                <Text
                  label="Fund Documents"
                  fontSize={`${theme.font_size.size_3xl}`}
                  lineheight="32px"
                  color={`${theme.colors.black_tertiary}`}
                />
              </Box>
            }
            columns={columns}
            dataSource={filteredDocumentData}
            locale={{
              emptyText: <NoDataFound text="No Documents" />,
            }}
            showSorterTooltip={false}
            pagination={
              fundDocumentData.length > 10
                ? {
                    position: ['bottomRight'],
                    showQuickJumper: true,
                    size: 'default',
                  }
                : false
            }
          />
        </Wrapper>
      </Container>
      <Modal
        visible={previewVisible}
        title={previewTitle}
        footer={null}
        onCancel={handlePreviewClose}
        width={1100}
        centered
      >
        {previewUrl && (
          previewMimeType === 'application/pdf' ? (
            <iframe
              src={previewUrl}
              style={{ width: '100%', height: '500px', border: 'none' }}
              title={previewTitle}
            />
          ) : previewMimeType.startsWith('image/') ? (
            <img
              alt={previewTitle}
              style={{ width: '100%' }}
              src={previewUrl}
            />
          ) : (
            <div style={{ textAlign: 'center', padding: '40px' }}>
              <FileOutlined style={{ fontSize: 48, color: '#999' }} />
              <p style={{ marginTop: 16, color: '#666' }}>
                Preview not available for this file type.
              </p>
              <a href={previewUrl} target="_blank" rel="noopener noreferrer">
                Open file
              </a>
            </div>
          )
        )}
      </Modal>
    </>
  );
};

export default FundDocumentsComponent;

